import type { Addendum, CosignMetaBody, UUID } from "@/core/types";
import type { ApiRequestWith } from "@/api/types";
import type {
  CreateNoteAddendumBody,
  GetNoteAddendumsBody,
  UpdateNoteAddendumBody,
} from "@/core/types/(api)/addendum";
import { getGroupAuthType } from "@/utils/authToken";
import { GROUP_AUTH_HEADER_NAME } from "@/api/constants";
import { httpAuth } from "@/api/httpAuth";

type AddendumRequestsTyped = {
  create_note_addendum: ApiRequestWith<
    Addendum,
    { body: CreateNoteAddendumBody; urlParams: { patientId: UUID } }
  >;
  get_note_addendum_cosign_details: ApiRequestWith<
    CosignMetaBody,
    { urlParams: { addendumId: string } }
  >;
  get_note_addendums: ApiRequestWith<
    { addendums: Addendum[] },
    { body: GetNoteAddendumsBody; urlParams: { patientId: UUID } }
  >;
  update_note_addendum: ApiRequestWith<
    Addendum,
    { body: UpdateNoteAddendumBody; urlParams: { patientId: UUID } }
  >;
};

export const addendumRequestsTyped: AddendumRequestsTyped = {
  create_note_addendum: function ({ body, context, urlParams }) {
    return httpAuth
      .post(`v1/patient_management/${urlParams.patientId}/create_note_addendum`, {
        context,
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
        json: body,
        // disable timeout for long-polling endpoint — needs more time than the default (10 s)
        timeout: false,
      })
      .json<Addendum>();
  },

  get_note_addendum_cosign_details: function ({ context, urlParams }) {
    return httpAuth
      .get(`/v1/cosignature/note_addendum/${urlParams.addendumId}`, {
        context: { showLoader: false, ...context },
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      })
      .json<CosignMetaBody>();
  },

  get_note_addendums: function ({ body, context, urlParams }) {
    return httpAuth
      .post(`v1/patient_management/${urlParams.patientId}/get_note_addendums`, {
        context,
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
        json: body,
      })
      .json<{ addendums: Addendum[] }>();
  },

  update_note_addendum: function ({ body, context, urlParams }) {
    return httpAuth
      .post(`v1/patient_management/${urlParams.patientId}/update_note_addendum`, {
        context,
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
        json: body,
      })
      .json<Addendum>();
  },
};
